import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { OperationResult, SubscriptionState } from '../../../admin/components/tools/UpgradeWizard/types';

interface UseSubscriptionStateQueryParams {
	accountId: string;
	enabled?: boolean;
}

export function useSubscriptionStateQuery({ accountId, enabled = true }: UseSubscriptionStateQueryParams) {
	const userSession = useAdminUserSession();

	return useQuery({
		queryKey: ['subscriptionState', accountId],
		queryFn: async () => {
			const response = await userSession.webServiceHelper.callAsync<OperationResult<SubscriptionState>>(
				`admin/BillingUtilities/GetSubscriptionStateByAccountId?accountId=${encodeURIComponent(accountId)}`,
				'GET'
			);

			// Handle both wrapped response { success, value } and unwrapped response
			if ('value' in response && 'success' in response) {
				if (!response.success || !response.value) {
					throw new Error(response.error || 'Failed to fetch subscription state');
				}
				return response.value;
			}

			return response as unknown as SubscriptionState;
		},
		enabled: enabled && !!accountId,
	});
}
